export const getAccessedAt = () => Date.now();